function Analytics() {
  // PUBLIC FUNCTIONS
  function pushDLAddToCart(currency, locale, item, variant, quantity) {
    dataLayer.push({ ecommerce: null });

    const v = variant ? item.variants.find((v) => v.id == variant) : item.variants.find((v) => v.available == true);
    const qty = quantity || 1;

    const object = {
      event: "add_to_cart",
      currency: currency,
      ecommerce: {
        value: (item.price * qty) / 100,
        items: [
          {
            item_id: item.id,
            item_name: item.title,
            item_brand: item.vendor,
            item_type: item.type,
            item_sku: v.sku,
            item_handle: item.handle,
            quantity: qty,
            item_variant: v.title,
            item_variant_id: v.id,
            price: item.price / 100,
            id: `shopify_${locale}_${item.id}_${v.id}`,
            google_business_vertical: "retail",
            index: 0,
            category_id: null,
            category_title: null,
            category_handle: null,
          },
        ],
      },
    };

    console.log("🚀 ~ pushDLAddToCart ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLAddToCartPlus(currency, locale, item) {
    dataLayer.push({ ecommerce: null });

    const tmp = JSON.parse(decodeURIComponent(item));

    const object = {
      event: "add_to_cart",
      currency: currency,
      ecommerce: {
        value: tmp.price / 100,
        items: [
          {
            item_id: tmp.product_id,
            item_name: tmp.product_title,
            item_brand: tmp.vendor,
            item_type: tmp.product_type,
            item_sku: tmp.sku,
            item_handle: tmp.handle,
            quantity: tmp.quantity,
            item_variant: tmp.variant_title,
            item_variant_id: tmp.variant_id,
            price: tmp.price / 100,
            id: `shopify_${locale}_${tmp.product_id}_${tmp.variant_id}`,
            google_business_vertical: "retail",
            index: 0,
            category_id: null,
            category_title: null,
            category_handle: null,
          },
        ],
      },
    };

    console.log("🚀 ~ pushDLAddToCart ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLRemoveFromCart(currency, locale, item) {
    dataLayer.push({ ecommerce: null });

    const tmp = JSON.parse(decodeURIComponent(item));

    const object = {
      event: "remove_from_cart",
      currency: currency,
      value: tmp.price / 100,
      ecommerce: {
        items: [
          {
            item_id: tmp.product_id,
            item_name: tmp.product_title,
            item_brand: tmp.vendor,
            item_type: tmp.product_type,
            item_sku: tmp.sku,
            item_handle: tmp.handle,
            quantity: tmp.quantity,
            item_variant: tmp.variant_title,
            item_variant_id: tmp.variant_id,
            price: tmp.price / 100,
            id: `shopify_${locale}_${tmp.product_id}_${tmp.variant_id}`,
            google_business_vertical: "retail",
            index: 0,
          },
        ],
      },
    };

    console.log("🚀 ~ pushDLRemoveFromCart ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLSearch(terms, results) {
    const object = {
      event: "search",
      search_items_result: results,
      search_result: results > 0 ? "OK" : "KO",
      keyword_search: terms,
    };

    console.log("🚀 ~ pushDLSearch ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLSelectItem(currency, item) {
    dataLayer.push({ ecommerce: null });

    const tmp = JSON.parse(decodeURIComponent(item));

    const object = {
      event: "select_item",
      currency,
      ecommerce: {
        items: [
          {
            item_id: tmp.id,
            item_name: tmp.title,
            item_brand: tmp.vendor,
            item_type: tmp.type,
            item_sku: tmp.sku,
            item_handle: tmp.handle,
            quantity: 1,
            item_variant: tmp.title,
            item_variant_id: tmp.id,
            price: tmp.price / 100,
            id: tmp.id,
            google_business_vertical: "retail",
            index: 0,
          },
        ],
      },
    };

    console.log("🚀 ~ pushDLSelectItem ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLViewCart(currency, locale, items, value) {
    dataLayer.push({ ecommerce: null });

    let quantity = 0;
    const temp = [];

    items.forEach((item, index) => {
      temp.push({
        index,
        item_brand: item.vendor,
        item_type: item.product_type,
        item_sku: item.sku,
        item_name: item.product_title,
        item_handle: item.handle,
        item_id: item.product_id,
        quantity: item.quantity,
        price: item.price / 100,
        id: `shopify_${locale}_${item.product_id}_${item.variant_id}`,
        item_variant: item.variant_title,
        item_variant_id: item.variant_id,
        business_vertical: "retail",
        item_list_id: "cart",
        item_list_name: "Cart",
      });

      quantity += item.quantity;
    });

    const object = {
      event: "view_cart",
      currency,
      ecommerce: {
        currency,
        value: value / 100,
        total_quantity: quantity,
        total_item: items.length,
        items: temp,
      },
    };

    console.log("🚀 ~ pushDLViewCart ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLViewItem(currency, item, variant) {
    dataLayer.push({ ecommerce: null });

    const v = variant ? item.variants.find((v) => v.id == variant) : item.variants.find((v) => v.available == true);

    const object = {
      event: "view_item",
      currency,
      ecommerce: {
        value: item.price / 100,
        items: [
          {
            item_id: item.id,
            item_name: item.title,
            item_brand: item.vendor,
            item_type: item.type,
            item_sku: variant ? v.sku : item.variants[0].sku,
            item_handle: item.handle,
            quantity: 1,
            item_variant: variant ? v.title : item.variants[0].title,
            item_variant_id: variant ? v.id : item.variants[0].id,
            price: item.price / 100,
            id: item.id,
            google_business_vertical: "retail",
            index: 0,
          },
        ],
      },
    };

    console.log("🚀 ~ pushDLViewItem ~ object:", object);
    dataLayer.push(object);
  }

  function pushDLViewItemList(currency, id, name, items) {
    dataLayer.push({ ecommerce: null });

    const temp = [];

    items.forEach((item, index) => {
      temp.push({
        index,
        item_brand: item.vendor,
        item_type: item.type,
        item_sku: item.variants[0].sku,
        item_name: item.title,
        item_handle: item.handle,
        item_id: item.id,
        quantity: 1,
        price: item.price / 100,
        id: item.id,
        item_variant: item.variants[0].title,
        item_variant_id: item.variants[0].id,
        business_vertical: "retail",
      });
    });

    const object = {
      event: "view_item_list",
      currency,
      ecommerce: {
        item_list_id: id,
        item_list_name: name,
        items: temp,
      },
    };

    console.log("🚀 ~ pushDLViewItemList ~ object:", object);
    dataLayer.push(object);
  }

  // UTILS FUNCTIONS
  async function init() {
    await document.addEventListener("DOMContentLoaded", async function () {
      // Load analytics script
    });
  }

  init();

  return {
    pushDLAddToCart: pushDLAddToCart,
    pushDLAddToCartPlus: pushDLAddToCartPlus,
    pushDLRemoveFromCart: pushDLRemoveFromCart,
    pushDLSearch: pushDLSearch,
    pushDLSelectItem: pushDLSelectItem,
    pushDLViewCart: pushDLViewCart,
    pushDLViewItem: pushDLViewItem,
    pushDLViewItemList: pushDLViewItemList,
  };
}
